module.exports = __webpack_public_path__ + "img/silk_oak_109s_list.0bcebb91.jpg";